(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1188],{

/***/ 19148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomHead; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


function CustomHead(_ref) {
  var children = _ref.children,
      title = _ref.title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("title", {
      children: [title, " | ", "SUPERMARKET Κρητικός"]
    }), children]
  });
}

/***/ }),

/***/ 36593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PageTitle; }
/* harmony export */ });
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13282);
/* harmony import */ var _PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




function PageTitle(_ref) {
  var title = _ref.title,
      heading = _ref.heading;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
    className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().section),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().content),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
        className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().title),
        children: title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().breadcrumbs),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
          href: "/",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
            className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().breadcrumbPrevious),
            children: "\u0391\u03C1\u03C7\u03B9\u03BA\u03AE"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().breadcrumbSeparator),
          children: "/"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          children: heading || title
        })]
      })]
    })
  });
}

/***/ }),

/***/ 58584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Faqs; }
});

// EXTERNAL MODULE: ./styles/pages/index.module.scss
var index_module = __webpack_require__(28833);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/components/CustomHead.jsx
var CustomHead = __webpack_require__(19148);
// EXTERNAL MODULE: ./node_modules/react-accessible-accordion/dist/es/index.js
var es = __webpack_require__(11876);
// EXTERNAL MODULE: ./styles/layout.module.scss
var layout_module = __webpack_require__(65447);
var layout_module_default = /*#__PURE__*/__webpack_require__.n(layout_module);
// EXTERNAL MODULE: ./src/components/FaqsLayout/FaqsLayout.module.scss
var FaqsLayout_module = __webpack_require__(50388);
var FaqsLayout_module_default = /*#__PURE__*/__webpack_require__.n(FaqsLayout_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/FaqsLayout/FaqsLayout.jsx






function FaqsLayout(_ref) {
  var faqCategories = _ref.faqCategories;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: (layout_module_default()).section,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (layout_module_default()).container,
      children: faqCategories.map(function (c) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (FaqsLayout_module_default()).row,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
            className: (FaqsLayout_module_default()).title,
            children: c.title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(es/* Accordion */.UQ, {
            children: c.fields.questions.map(function (q) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)(es/* AccordionItem */.Qd, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(es/* AccordionItemHeading */.Ol, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(es/* AccordionItemButton */.on, {
                    children: q.question
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(es/* AccordionItemPanel */.Mt, {
                  dangerouslySetInnerHTML: {
                    __html: q.answer
                  }
                })]
              }, q.question);
            })
          })]
        }, c.uuid);
      })
    })
  });
}

FaqsLayout.defaultProps = {
  faqCategories: []
};
/* harmony default export */ var FaqsLayout_FaqsLayout = (FaqsLayout);
// EXTERNAL MODULE: ./src/components/Footer/Footer.jsx + 5 modules
var Footer = __webpack_require__(31875);
// EXTERNAL MODULE: ./src/components/Header/Header.jsx + 8 modules
var Header = __webpack_require__(3266);
// EXTERNAL MODULE: ./src/components/Navigation/Navigation.jsx
var Navigation = __webpack_require__(86894);
// EXTERNAL MODULE: ./src/components/Page Title/PageTitle.jsx
var PageTitle = __webpack_require__(36593);
;// CONCATENATED MODULE: ./src/pages/faqs.jsx










var __N_SSG = true;
function Faqs(_ref) {
  var data = _ref.data,
      footerLinks = _ref.footerLinks,
      navigation = _ref.navigation;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
      className: (index_module_default()).headerContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {
        navigation: navigation
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Navigation/* default */.Z, {
        navigation: navigation
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CustomHead/* default */.Z, {
      title: "\u03A3\u03C5\u03C7\u03BD\u03AD\u03C2 \u0395\u03C1\u03C9\u03C4\u03AE\u03C3\u03B5\u03B9\u03C2"
    }, "title"), /*#__PURE__*/(0,jsx_runtime.jsx)(PageTitle/* default */.Z, {
      title: "\u03A3\u03C5\u03C7\u03BD\u03AD\u03C2 \u0395\u03C1\u03C9\u03C4\u03AE\u03C3\u03B5\u03B9\u03C2"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FaqsLayout_FaqsLayout, {
      faqCategories: data
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {
      footerLinks: footerLinks
    })]
  });
}

/***/ }),

/***/ 23830:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faqs",
      function () {
        return __webpack_require__(58584);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50388:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"row":"FaqsLayout_row__m9fju","title":"FaqsLayout_title___atpN","question":"FaqsLayout_question__ignwZ","content":"FaqsLayout_content__f2jDK"};

/***/ }),

/***/ 13282:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"PageTitle_section__JW_pb","content":"PageTitle_content__b6zB3","title":"PageTitle_title__MR_HW","breadcrumbs":"PageTitle_breadcrumbs__yPd2_","breadcrumbSeparator":"PageTitle_breadcrumbSeparator__bNku9","breadcrumbPrevious":"PageTitle_breadcrumbPrevious__o_DvH"};

/***/ }),

/***/ 65447:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"brandFontFamily":"\"Roboto\",Helvetica,Arial,sans-serif","container":"layout_container__8mgcn","section":"layout_section__q1Enk","row":"layout_row___Mosi"};

/***/ }),

/***/ 28833:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"index_headerContainer__J9svF"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5937,9866,1228,4617,5445,3609,3996,4843,1876,9950,9774,2888,179], function() { return __webpack_exec__(16395), __webpack_exec__(23830); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);